// Todo: Further define these interfaces as we continue to sprinkle in TypeScript to this project.
import { IServiceProvider } from 'src/services/api/ServiceRequestDashboard/apiContracts';

export interface IssueType {
  issueType: string;
  issueTypeId: string;
}

export interface IContactPickerState {
  dropdownOpen: boolean;
  openCalendar: boolean;
  contact: Partial<IServiceProvider> | {};
  scheduling_url: string;
  addEvent: boolean;
}

// Checks if an array contains issue type objects or simple strings.
const isIssueTypeArray = (items: any[]): items is IssueType[] => {
  return (
    items.length > 0 && typeof items[0] !== 'string' && 'issueType' in items[0]
  );
};

// Adapter function to transform the new API response format to the format expected by CategoryPills.
const adaptToCategoryPills = (items: IssueType[] | string[]): string[] => {
  if (!items || items.length === 0) return [];

  // Check if the items are IssueType objects.
  if (isIssueTypeArray(items)) {
    return items.map((item: IssueType): string => item.issueType);
  }

  // If they're already strings, just return them.
  return items;
};

const isPopulatedContact = (
  contact: Partial<IServiceProvider>
): contact is IServiceProvider => {
  return (
    contact !== null &&
    contact !== undefined &&
    'userId' in contact &&
    contact.userId !== undefined
  );
};

// We can add more utility functions for the Service Request page here :)

export { isIssueTypeArray, adaptToCategoryPills, isPopulatedContact };
